module.exports = __webpack_public_path__ + "img/voltage.2669d45c.png";